import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { QUOTE_STATUS, tl } from "@/lib/utils-tr";

function QuoteView({ q }) {
  if (!q) return <div className="text-center py-24 text-slate-400">Teklif bulunamadı.</div>;
  const sent = q.status === "gonderildi";
  const h = q.hesaplama || {};
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
        <div>
          <h1 className="font-head text-2xl font-bold text-slate-900">{q.quote_no}</h1>
          <p className="text-sm text-slate-500 mt-1">{(q.created_at || "").slice(0, 10)} · {q.musteri?.ad}</p>
        </div>
        <Badge variant="outline" className={QUOTE_STATUS[q.status]?.cls}>{QUOTE_STATUS[q.status]?.label}</Badge>
      </div>

      <section className="bg-white border rounded-xl p-5 mb-6">
        <h2 className="font-head font-semibold text-slate-900 mb-3">Talep Ettiğiniz Ürünler</h2>
        <div className="divide-y">
          {q.original_items?.map((it, i) => (
            <div key={i} className="py-2.5 flex justify-between gap-3 text-sm">
              <div>
                <div className="font-medium text-slate-800">{it.urun_adi}</div>
                <div className="text-xs text-slate-500">{it.urun_kodu} · {it.marka}</div>
                {it.musteri_notu && <div className="text-xs text-slate-400 mt-0.5">Not: {it.musteri_notu}</div>}
              </div>
              <div className="text-right shrink-0 text-slate-600">{it.adet} × {it.ambalaj}</div>
            </div>
          ))}
          {q.serbest_talepler?.map((f, i) => (
            <div key={i} className="py-2.5 text-sm text-amber-700">Serbest talep: {f.metin}</div>
          ))}
        </div>
      </section>

      {sent ? (
        <section className="bg-white border rounded-xl p-5" data-testid="quote-pricing">
          <h2 className="font-head font-semibold text-slate-900 mb-3">Size Sunulan Teklif</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-left text-slate-500 border-b">
                <th className="py-2">Ürün</th><th className="py-2">Ambalaj</th><th className="py-2 text-right">Adet</th>
                <th className="py-2 text-right">Birim</th><th className="py-2 text-right">Tutar</th>
              </tr></thead>
              <tbody>
                {q.revizyon_items?.map((it, i) => (
                  <tr key={i} className="border-b last:border-0">
                    <td className="py-2">{it.urun_adi}</td>
                    <td className="py-2">{it.ambalaj}</td>
                    <td className="py-2 text-right">{it.adet}</td>
                    <td className="py-2 text-right">{it.uygunluk_ok === false ? "—" : tl(it.birim_fiyat_tl)}</td>
                    <td className="py-2 text-right font-medium">
                      {it.uygunluk_ok === false ? <span className="text-amber-600 text-xs">İnceleme gerekli</span> : tl(it.satir_tl)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="mt-4 ml-auto max-w-xs space-y-1.5 text-sm">
            <Row l="Ara Toplam (KDV hariç)" v={tl(h.ara_toplam_tl)} />
            {h.iskonto_tl > 0 && <Row l="İskonto" v={"- " + tl(h.iskonto_tl)} />}
            <Row l="KDV" v={tl(h.kdv_tl)} />
            {h.nakliye_tl > 0 && <Row l="Nakliye" v={tl(h.nakliye_tl)} />}
            <div className="border-t pt-2 flex justify-between font-bold text-slate-900">
              <span>Genel Toplam</span><span data-testid="quote-grand-total">{tl(h.genel_toplam_tl)}</span>
            </div>
          </div>
          {h.eksik_kur && <p className="text-xs text-amber-600 mt-2">Bazı kalemler için kur bilgisi beklenmektedir.</p>}
          <div className="mt-5 text-sm text-slate-600 space-y-1 border-t pt-4">
            {q.gecerlilik && <p><b>Geçerlilik:</b> {q.gecerlilik}</p>}
            {q.odeme_sekli && <p><b>Ödeme:</b> {q.odeme_sekli}</p>}
            {q.teslim_suresi && <p><b>Teslim:</b> {q.teslim_suresi}</p>}
            {q.sevkiyat_yontemi && <p><b>Sevkiyat:</b> {q.sevkiyat_yontemi}</p>}
            {q.sartlar && <p className="text-xs text-slate-400 mt-2">{q.sartlar}</p>}
          </div>
        </section>
      ) : (
        <div className="bg-blue-50 border border-blue-200 rounded-xl p-5 text-sm text-blue-800" data-testid="quote-pending">
          Talebiniz değerlendiriliyor. Teklifiniz hazırlandığında e-posta ile bilgilendirileceksiniz.
        </div>
      )}
    </div>
  );
}

const Row = ({ l, v }) => (
  <div className="flex justify-between text-slate-600"><span>{l}</span><span>{v}</span></div>
);

export function QuoteViewPage() {
  const { quote_no } = useParams();
  const [q, setQ] = useState(undefined);
  useEffect(() => {
    api.get(`/quotes/${quote_no}`).then((r) => {
      setQ(r.data);
      document.title = `${r.data.quote_no} | Molar Kimya`;
    }).catch(() => setQ(null));
  }, [quote_no]);
  if (q === undefined) return <div className="text-center py-24 text-slate-400">Yükleniyor...</div>;
  return <QuoteView q={q} />;
}

export function TrackQuotePage() {
  const { token } = useParams();
  const [q, setQ] = useState(undefined);
  useEffect(() => {
    api.get(`/quotes/track/${token}`).then((r) => {
      setQ(r.data);
      document.title = `${r.data.quote_no} | Molar Kimya`;
    }).catch(() => setQ(null));
  }, [token]);
  if (q === undefined) return <div className="text-center py-24 text-slate-400">Yükleniyor...</div>;
  return <QuoteView q={q} />;
}
